import ProfilePage from '~/pageComponents/ProfilePage';
import getArtistPageProps from '~/pageProps/artist';

export default ProfilePage;

export const getServerSideProps = getArtistPageProps;
